<p>shared-methods works!</p>
